import { render } from "./UserGrid.vue?vue&type=template&id=7cc9d6b7&scoped=true"
import script from "./UserGrid.vue?vue&type=script&lang=js"
export * from "./UserGrid.vue?vue&type=script&lang=js"

import "./UserGrid.vue?vue&type=style&index=0&id=7cc9d6b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7cc9d6b7"

export default script